"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ExtendableError_1 = (0, tslib_1.__importDefault)(require("./ExtendableError"));
var NotAFunctionError = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(NotAFunctionError, _super);
    function NotAFunctionError(functionName, expectedType, givenType) {
        return _super.call(this, "The function ".concat(functionName, " expected a ").concat(expectedType, ", ").concat(givenType, " given.")) || this;
    }
    return NotAFunctionError;
}(ExtendableError_1.default));
exports.default = NotAFunctionError;
//# sourceMappingURL=NotAFunctionError.js.map